import PropTypes from "prop-types";
import classnames from "classnames";

const Stepper = ({ steps, activeStep }) => (
    <div className="flex items-center gap-2">
        {steps.map((step, index) => {
            const isCompleted = index < activeStep;
            const isActive = index === activeStep;
            return (
                <div key={step.label} className="flex items-center gap-2">
                    <span
                        className={classnames(
                            "grid h-7 w-7 shrink-0 place-items-center rounded-full text-xs font-semibold",
                            isCompleted && "bg-success text-white",
                            isActive && "bg-navy text-white",
                            !isCompleted && !isActive && "bg-gray-200 text-muted"
                        )}>
                        {isCompleted ? "✓" : index + 1}
                    </span>
                    <span className={classnames("text-sm", isActive ? "font-medium text-gray-900" : "text-muted")}>
                        {step.label}
                    </span>
                    {index < steps.length - 1 && <div className="mx-2 h-px w-8 bg-gray-200" />}
                </div>
            );
        })}
    </div>
);

Stepper.propTypes = {
    steps: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired
    })).isRequired,
    activeStep: PropTypes.number.isRequired
};

export default Stepper;
